// Toegangscode (4014, zelfde voor elke winkel). Open tussen de menu's; terug naar de kassa = weer op slot.
let ontgrendeld = false;
export const vergrendel = () => { ontgrendeld = false; };
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { foutTekst } from "../api";

export default function CodeSlot({ children }) {
  const [ok, setOk] = useState(ontgrendeld);
  const [code, setCode] = useState("");
  const [fout, setFout] = useState("");
  const [bezig, setBezig] = useState(ontgrendeld);
  const nav = useNavigate();
  if (ok) return children;

  const open = async () => {
    setBezig(true); setFout("");
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/kassa/dagontvangsten/code`, { code: code.trim() }, { withCredentials: true });
      ontgrendeld = true; setOk(true);
    } catch (e) { setFout(e?.response?.status === 401 ? "Meld je eerst aan op de kassa." : foutTekst(e)); setCode(""); }
    setBezig(false);
  };

  return (
    <div className="min-h-screen bg-[#f1f4f9] flex items-center justify-center p-4" data-testid="dagontv-codeslot">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-7 text-center">
        <div className="w-14 h-14 rounded-2xl bg-blue-600 text-white font-extrabold text-2xl mx-auto mb-3 flex items-center justify-center">S</div>
        <h2 className="text-xl font-bold text-slate-800">Beveiligd menu</h2>
        <p className="text-sm text-slate-500 mt-1 mb-4">Alleen voor de beheerder — geef de toegangscode</p>
        <input type="password" inputMode="numeric" autoFocus value={code} data-testid="dagontv-code-input"
          onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => e.key === "Enter" && code.trim() && open()}
          className="w-full border border-slate-300 rounded-xl px-4 py-3 text-2xl text-center tracking-[0.5em] outline-none focus:border-blue-600" />
        {fout && <div className="mt-3 p-2.5 rounded-xl bg-red-50 text-red-700 text-sm" data-testid="dagontv-code-error">{fout}</div>}
        <button disabled={bezig || !code.trim()} onClick={open} data-testid="dagontv-code-submit"
          className="w-full mt-4 bg-blue-600 disabled:opacity-40 text-white font-semibold rounded-xl py-3">{bezig ? "Bezig…" : "Openen"}</button>
        <button onClick={() => nav("/kassa")} data-testid="dagontv-code-back" className="w-full mt-2 text-sm text-slate-500 py-2">← Terug naar de kassa</button>
      </div>
    </div>
  );
}
